var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-alignment-center-center gray-6 bg"},[_c('div',{staticClass:"md-layout-item md-size-33"},[_c('email-verification-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }